export const API_CONFIG = {
  baseURL: "",
  apiPath: "/api",
  timeout: 45000,
};

export const API_ENDPOINTS = {
  auth: {
    login: "/api/auth/login",
    refresh: "/api/auth/refresh",
    logout: "/api/auth/logout",
    mfaVerify: "/api/auth/mfa/verify",
    resendEmail: "/api/auth/resend/email",
    resendPhone: "/api/auth/resend/phone",
  },
  datasources: {
    list: "/api/datasources",
    linkOrg: (datasourceId: string, orgId: string) =>
      `/api/datasources/${datasourceId}/orgs/${orgId}`,
  },
  admin: {
    roles: "/api/admin/roles",
    rolesBulk: "/api/admin/roles/bulk",
    organisations: "/api/admin/organisations",
    organisationDetail: (id: string) => `/api/admin/organisations/${id}`,
    provisionOrg: "/api/admin/organisations/provision",
    inviteOrgUser: (orgId: string) => `/api/admin/organisations/${orgId}/users/invite`,
    deleteOrg: (id: string) => `/api/organisations/${id}`,
    removeMember: (orgId: string, userId: string) => `/api/organisations/${orgId}/members/${userId}`,
  },
};
